import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import fondoLateral from "./assets/asesor.jpg";
import './styles/disenocita.css';

export default function CitaForm() {
  const navigate = useNavigate();
  const [horasDisponibles, setHorario] = useState([]);

  const [formData, setFormData] = useState({
    nombre: "",
    tipo: "",
    correo: "",
    telefono: "",
    fecha: "",
    hora: "",
  });

  useEffect(() => {
    fetchHorario(formData.fecha);
  }, [formData.fecha]);

  const fetchHorario = async (fecha) => {
    if (!fecha) return;
    try {
      const response = await fetch("https://ricardodiaztuasesorfinanciero.com/api/horariocita", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ fecha }),
      });
      const data = await response.json();
      if (data && data.resultado) {
        setHorario(data.resultado);
      } else {
        console.error("No se puede oiga[1h]");
      }
    } catch (error) {
      console.error("Error al obtener las citas", error);
    }
  };

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  const handleCita = async () => {
    const correoValido = /^[a-zA-Z0-9._%+-]+@(gmail|hotmail|outlook|yahoo)\.com$/;
    if (!formData.nombre || !formData.tipo || !formData.correo || !formData.telefono || !formData.fecha || !formData.hora) {
      Swal.fire('Campos incompletos', 'Por favor llena todos los campos obligatorios.', 'warning');
      return;
    }
    if (!correoValido.test(formData.correo)) {
      Swal.fire("El correo debe ser de dominio @gmail.com, @hotmail.com, @outlook.com o @yahoo.com");
      return;
    }
    if (!/^[0-9]{10}$/.test(formData.telefono)) {
      Swal.fire("El número de teléfono debe tener 10 dígitos");
      return;
    }

    try {
      const response = await fetch("https://ricardodiaztuasesorfinanciero.com/api/crearcita", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        Swal.fire({
          title: "¡Gracias! Nos pondremos en contacto pronto.",
          icon: "success",
        });

      setFormData({
        nombre: "",
        tipo: "",
        correo: "",
        telefono: "",
        fecha: "",
        hora: "",
      });
      setHorario([]);

      } else {
          Swal.fire({
          title: "¡Gracias! Nos pondremos en contacto pronto.",
          icon: "success",
        });
        //Swal.fire("Error", result.error || "No se pudo registrar la cita", "error");
      }
    } catch (error) {
      console.error("Error al enviar los datos", error);
      Swal.fire("Error en la conexión");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Validación para que no pongan fechas anteriores
    if (name === "fecha") {
      const today = getTodayDate();
      if (value < today) {
        Swal.fire("Fecha inválida", "No puedes seleccionar una fecha anterior a hoy.", "warning");
        setFormData((prev) => ({ ...prev, [name]: "" }));
        return;
      }
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <>
      <button
        onClick={() => navigate('/')}
        className="cita-back"
      >
        ← Regresar al Menú
      </button>
      <div className="cita-container">
        <div className="cita-left">
          <div 
            className="cita-image"
            style={{ backgroundImage: `url(${fondoLateral})` }}
          ></div>
        </div>

        <div className="cita-right">
          <div className="cita-info">
            <h2>
              ¿Interesado en un plan de ahorro o mis servicios?
            </h2>
            <p>
              No lo pienses más. Agenda una cita sin compromiso y recibe asesoría personalizada.
            </p>
            <p>
              Solo necesitas unos minutos para llenar el formulario y dar el primer paso hacia una vida financiera más segura.
              ¡Estaré encantado de acompañarte en este camino!
            </p>
          </div>

          <div className="cita-form-container">
            <h3>
              Agenda tu cita
            </h3>
            <form className="cita-form" onSubmit={(e) => e.preventDefault()}>
              <div className="cita-form-group">
                <label>Nombre completo</label>
                <input type="text" name="nombre" value={formData.nombre} onChange={handleChange} />
              </div>

              <div className="cita-form-group">
                <label>Tipo</label>
                <select name="tipo" value={formData.tipo} onChange={handleChange}>
                  <option value="">Seleccione el formato</option>
                  <option value="Virtual">Virtual</option>
                  <option value="Presencial">Presencial</option>
                </select>
              </div>

              <div className="cita-form-group">
                <label>Correo electrónico</label>
                <input type="text" name="correo" value={formData.correo} onChange={handleChange} />
              </div>

              <div className="cita-form-group">
                <label>Número de teléfono</label>
                <input
                  type="tel"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleChange}
                  pattern="[0-9]{10}"
                  placeholder="Ej. 6531251121"
                />
              </div>

              <div className="cita-form-group">
                <label>Fecha de la cita</label>
                <input
                  type="date"
                  name="fecha"
                  value={formData.fecha}
                  onChange={(e) => {
                    handleChange(e);
                    fetchHorario(e.target.value);
                  }}
                  min={getTodayDate()}
                />
              </div>

              <div className="cita-form-group">
                <label>Hora disponible</label>
                <select name="hora" value={formData.hora} onChange={handleChange}>
                  <option value="">Selecciona una hora</option>
                  {horasDisponibles.map((h) => (
                    <option key={h.hora} value={h.hora}>
                      {h.hora}
                    </option>
                  ))}
                </select>
              </div>

              <button onClick={handleCita} type="submit" className="cita-btn">
                Reservar cita
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

